import { Box, Typography } from "@mui/material";
import useAPI from "../../../../../../../api/hooks/useAPI";
import useColors from "../../../../../../../api/hooks/useColors";
import SvgToIcon from "../../../../../../../icons/SvgToIcon";
import { VerticalBottomLine } from "./Log";
import { expandButtonType, logIconsMapping } from "./LogIconsMapping";

export default function ExpandButton({
  logsCount,
  setShowAllLogs,
  includeBottomVerticalLine,
  controlId,
}) {
  const colors = useColors();
  const { trackEvent } = useAPI();
  const handleClick = () => {
    trackEvent(`User expanded the activity logs for control: ${controlId}`);
    setShowAllLogs((prevState) => !prevState);
  };

  return (
    <Box display="flex" height="36px" alignItems="center">
      <Box
        width="24px"
        height="100%"
        padding="10px 4px 0 4px"
        position="relative"
      >
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          width="16px"
          height="16px"
        >
          <SvgToIcon
            IconLogo={logIconsMapping[expandButtonType]}
            width={16}
            height={16}
            style={{ color: colors.action_active }}
          />
        </Box>
        {includeBottomVerticalLine && <VerticalBottomLine colors={colors} />}
      </Box>
      <Box padding="8px">
        <Typography
          onClick={handleClick}
          variant="body2"
          color={colors.text_help}
          sx={{ cursor: "pointer" }}
        >
          Show {logsCount} events...
        </Typography>
      </Box>
    </Box>
  );
}
